<template>
  <div class="" id="screenshot">
    <div class="q-mb-lg">
      <div class="row">
        <div class="col-6 row q-px-sm q-ml-sm">
          <q-btn-dropdown class="col q-mr-sm q-mt-lg" :label="campaign_name">
            <q-list>
              <q-item clickable v-for="item in getCampaignItems" :key="item" v-close-popup @click="setCampaignName(item)">
                <q-item-section>
                  <q-item-label @click="trackingbutton(item)">{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </div>
        <div class="col-3">
        </div>
        <q-dialog v-model="seamless">
          <q-card>
            <q-card-section>
              <div class="text-h6">Alert</div>
            </q-card-section>
            <q-card-section class="q-pt-none">
              Mail has sent successfully!
            </q-card-section>
            <q-card-actions align="right">
              <q-btn flat label="OK" color="primary" v-close-popup></q-btn>
            </q-card-actions>
          </q-card>
        </q-dialog>
        <div class="dateDropDown col q-ml-md q-mr-md q-mt-lg"
          style="align-items: flex-end!important; display:flex!important;">
          <q-input filled v-model="dateValue"
            style="width:250px;background-color: white !important;box-shadow: 0px 4px 12px #00000033 !important;">
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date v-model="dateRange" :options="optionsFn" range @click="setDate(campaign_name)">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </div>
    </div>
    <div class="row q-mt-md">
      <div class="col-6 q-px-md">
        <div class="title-1 q-pa-sm">
          <h5>Traffic</h5>
        </div>
        <div class="row">
          <div class="col-3 boxdashboard">
            <div class="row num">
              {{ impressions.toLocaleString("en-IN") }}
            </div>
            <div class="row">
              Impressions
            </div>
          </div>
          <div class="col-3 boxdashboard">
            <div class="row num">
              {{ clicks.toLocaleString("en-IN") }}
            </div>
            <div class="row">
              Clicks
            </div>
          </div>
          <div class="col-3 boxdashboard">
            <div class="row num">{{ ctr }} </div>
            <div class="row">
              CTR
            </div>
          </div>
          <div class="col-3 boxdashboard">
            <div class="row num">{{ convRate }} </div>
            <div class="row">
              Conversion Rate
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 q-px-md">
        <div class="title-1 q-pa-sm">
          <h5>Sales</h5>
        </div>
        <div class="row">
          <div class="col-3 boxdashboard">
            <div class="row num">₹ {{ sales7d.toLocaleString("en-IN") }}</div>
            <div class="row">
              Advertisement Sales
            </div>
          </div>
          <div class="col-3 boxdashboard">
            <div class="row num">{{ OrdersClick }}</div>
            <div class="row">
              Orders
            </div>
          </div>
          <div class="col-3 boxdashboard">
            <div class="row num">{{ roas }}</div>
            <div class="row">
              ROAS
            </div>
          </div>
          <div class="col-3 boxdashboard">
            <div class="row num">{{ acos }}</div>
            <div class="row">
              ACOS
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row q-mt-sm q-px-md">
      <div class="graph col">
        <div class="box-graph q-mt-md">
          <h5>Impressions and Clicks by date</h5>
        </div>
        <apexchart type=line height=400 :options="chartOptions" :series="series" />
      </div>
      <div class="q-ml-lg graph col">
        <div class="box-graph q-mt-md">
          <h5>Sales and Cost by date</h5>
        </div>
        <apexchart type=bar height=400 :options="chartOptions1" :series="series1" />
      </div>
    </div>
    <div class="report-button q-mt-sm q-mb-sm">
      <q-btn class="btn q-mr-lg" style="background: #102689 0% 0% no-repeat padding-box;
                            border-radius: 5px;
                            color:white;
                           " @click="generatePDF()">Generate Report</q-btn>
      <q-btn class="btn q-mr-lg" style="background: #102689 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color:white;" @click="sendMail()">Mail Report</q-btn>
    </div>
  </div>
</template>
  
<script>
import { ref } from "vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export default {
  setup() {
    const dateRange = ref({ from: "01-01-2022", to: "05-1-2022" });
    return {
      dateRange,
      optionsFn(dateRange) {
        return dateRange >= this.min_date && dateRange <= this.max_date;
      },
    };
  },
  data() {
    return {
      isAuthenticated: false,
      preview: false,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      seller_name: "select Seller",
      seller_list: ["seller 1", "seller 2"],
      campaign_name: "all",
      campaign_list: ["Campaign1", "Campaign2"],
      selected_date: "select Date",
      date_list: [],
      impressions: 0,
      campaignName: "all",
      clicks: 0,
      OrdersClick: 0,
      sales7d: 0,
      ctr: 0,
      dateValue: "",
      data: [],
      convRate: 0,
      acos: 0,
      roas: 0,
      cost: 0,
      data_temp: [],
      clicksList: [],
      impressionsList: [],
      sales7dList: [],
      costList: [],
      date: [],
      start_date: "",
      end_date: "",
      campaign: "",
      min_date: "",
      max_date: "",
      seamless: false,
      series: [
        {
          name: "Impressions",
          type: "column",
          data: [],
        },
        {
          name: "Clicks",
          type: "line",
          data: [],
        },
      ],
      chartOptions: {
        stroke: {
          width: [0, 4],
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
        },
        labels: [],
        xaxis: {},
        yaxis: [
          {
            title: {
              text: "Impressions",
              style: {
                fontSize: "13px",
                fontFamily: "'Poppins', sans-serif",
              },
            },
          },
          {
            opposite: true,
            title: {
              text: "Clicks",
              style: {
                fontSize: "13px",
                fontFamily: "'Poppins', sans-serif",
              },
            },
          },
        ],
      },
      series1: [
        {
          name: "Sales",
          data: [],
        },
        {
          name: "Cost",
          data: [],
        },
      ],
      chartOptions1: {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: "Sales and Cost",
            style: {
              fontSize: "13px",
              fontFamily: "'Poppins', sans-serif",
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "Rs " + val + " thousand";
            },
          },
        },
      },
    };
  },
  mounted() {
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    if (this.$cookies.isKey("login_authentication")) {
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$store.dispatch(
          "setPathName",
          "/amazonadoptimization/adperfomacereports"
        );
        this.$q.loading.hide();
        this.isAuthenticated = true;
        this.$q.loading.show({
          message: "loading...",
        });
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    } else if (this.$cookies.isKey("login_authentication1")) {
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$store.dispatch(
          "setPathName",
          "/amazonadoptimization/adperfomacereports"
        );
        this.$q.loading.hide();
        this.isAuthenticated = true;
        this.$q.loading.show({
          message: "loading...",
        });
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    } else if (this.$cookies.isKey("login_authentication2")) {
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      //console.log("decrypt: ", decryptedText);
      if (decryptedText == "authenticated") {
        this.$store.dispatch(
          "setPathName",
          "/amazonadoptimization/adperfomacereports"
        );
        this.$q.loading.hide();
        this.isAuthenticated = true;
        this.$q.loading.show({
          message: "loading...",
        });
      } else {
        this.$q.loading.hide();
        this.$router.push({
          name: "NotAuthenticated",
        });
        return;
      }
    } else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }
  },
  created() {
    var productsURL = this.api_url + "/dashboard/ad_dashbrd1_get_data";
    this.$http
      .post(productsURL, this.defaultCall())
      .then((response) => {
        if (response.data == null) {
          this.$router.push("/home/" + this.$org_encryprt.label);
        }
        // let result = response.data;
        // console.log("test",result)
        this.data = response.data;
        // console.log("result :", result);
        this.data_temp = response.data;
        this.ctr = response.data["ctr"];
        this.convRate = response.data['conversion_rate'];
        this.acos = response.data['acos'];
        this.roas = response.data['roas'];
        this.impressions = response.data['impression'];
        this.clicks = response.data['clicks'];
        this.OrdersClick = response.data['orders'];
        this.sales7d = response.data['sales'];
        this.cost = response.data['cost'];
        let result = response.data['graph_data'];
        this.dateRange.from = this.data_temp['min_date'];
        this.dateRange.to = this.data_temp['max_date'];
        var dateinput = this.dateRange.from.split("-");
        this.min_date = dateinput.join('/')
        this.min_date = this.data_temp['min_date'];
        var dateinput = this.dateRange.to.split("-");
        this.max_date = dateinput.join('/');
        this.dateValue = this.dateRange.from + " to " + this.dateRange.to
        let data3 = result.map((item) =>
          item.date
        );
        this.date = data3
        let data1 = result.map((item) =>
          item.clicks
        );
        this.clicksList = data1;
        let data2 = result.map((item) =>
          item.impressions
        );
        this.impressionsList = data2;
        let data4 = result.map((item) =>
          item.sales7d
        );
        this.sales7dList = data4;
        let data5 = result.map((item) =>
          item.cost
        );
        this.costList = data5;
        this.campaignName = this.data['campaigns'];
        this.campaignName.push("all")
        this.series = [{
          name: 'Impressions',
          type: 'column',
          data: this.impressionsList.filter((_, i) => i % parseInt(this.impressionsList.length * 0.09) === 0)
        }, {
          name: 'Clicks',
          type: 'line',
          data: this.clicksList.filter((_, i) => i % parseInt(this.impressionsList.length * 0.09) === 0)
        }],
          this.chartOptions = {
            labels: this.date.filter((_, i) => i % parseInt(this.impressionsList.length * 0.09) === 0),
          }
        this.series1 = [{
          data: this.sales7dList.filter((_, i) => i % parseInt(this.sales7dList.length * 0.09) === 0)
        }, {
          data: this.costList.filter((_, i) => i % parseInt(this.sales7dList.length * 0.09) === 0)
        }]
        this.chartOptions1 = {
          xaxis: {
            categories: this.date.filter((_, i) => i % parseInt(this.sales7dList.length * 0.09) === 0),
          },
        }
        this.$q.loading.hide();
      }).catch(() => {
        this.$router.push("/home/" + this.$org_encryprt.label);
      });
  },
  computed : {
    getCampaignItems() {
      const email = this.$store.state.credentials['attributes']['email'];
      // Check if the email is 'support@uniqin.ai'
      if (email === 'support@uniqin.ai') {
        // Return 'sample' instead of your data
        return ['sample'];
      } else {
        // Return your data based on your logic
        return this.campaignName; // Replace with your data source
      }

    },

  },
  methods: {
    trackingbutton(items){
      this.$mixpanel.track('Campaign Report/CampaignNames',{
        info : `user selected ${items} this Campaign`
      })
    },
    generatePDF() {
      this.$mixpanel.track('Campaign Report/GenerateReport',{
        info : `user Generated Report`
      })
      const element = document.getElementById("screenshot");
      const scale = window.devicePixelRatio;
      const options = {
        scale: scale,
      };
      html2canvas(element, options).then((canvas) => {
        const pdf = new jsPDF();
        const imgData = canvas.toDataURL("image/png", 1.0);
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const ratio = imgProps.height / imgProps.width;
        const imgWidth = pdfWidth;
        const imgHeight = pdfWidth * ratio;
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        pdf.save("Report.pdf");
        //console.log(pdf);
        // var formData1 = new FormData();
        // formData1.append('file');
      });
    },
    sendMail() {
      this.$mixpanel.track('Campaign Report/MailReport',{
        info : `user Mailed the Report`
      })
      this.$q.loading.show({
        message: "Sending Mail...",
      });
      const element = document.getElementById("screenshot");
      const scale = window.devicePixelRatio;
      const options = {
        scale: scale,
      };
      html2canvas(element, options).then((canvas) => {
        const pdf = new jsPDF();
        const imgData = canvas.toDataURL("image/png", 1.0);
        let postURL =
          this.api_url +
          `/amazon-ad/amazonadperformance/uploadfile/` +
          this.$org_id.label;
        //console.log(postURL)
        this.$http.post(postURL, [{ dataUrl: imgData }]).then((response) => {
          this.$q.loading.hide();
          //console.log(response)
          this.seamless = true;
        });
      });
    },
    optionsFn(dateRange) {
      return dateRange >= this.min_date && dateRange <= this.max_date;
    },
    defaultCall() {
      return [
        {
          start_date: null,
          end_date: null,
          campaign: "all",
          org_id: this.$org_id.label.toString(),
        },
      ];
    },
    Backendcall() {
      return [
        {
          start_date: this.dateRange.from,
          end_date: this.dateRange.to,
          campaign: this.campaign_name,
          org_id: this.$org_id.label.toString(),
        },
      ];
    },
    setDate() {
      this.dateValue = this.dateRange.from + " to " + this.dateRange.to;
      this.apicall(this.campaign_name);
    },
    setCampaignName(item) {
      this.$q.loading.show({});
      this.apicall(item);
      // this.generateGraph();
    },
    apicall(item) {
      this.campaign_name = item;
      var productsURL = this.api_url + "/dashboard/ad_dashbrd1_get_data";
      this.$http.post(productsURL, this.Backendcall()).then((response) => {
        this.ctr = response.data["ctr"];
        this.convRate = response.data["conversion_rate"];
        this.acos = response.data["acos"];
        this.roas = response.data["roas"];
        this.impressions = response.data["impression"];
        this.clicks = response.data["clicks"];
        this.OrdersClick = response.data["orders"];
        this.sales7d = response.data["sales"];
        this.cost = response.data["cost"];
        let result = response.data["graph_data"];
        this.data_temp = response.data;
        let data3 = result.map((item) => item.date);
        this.date = data3;
        let data1 = result.map((item) => item.clicks);
        this.clicksList = data1;
        let data2 = result.map((item) => item.impressions);
        this.impressionsList = data2;
        let data4 = result.map((item) => item.sales7d);
        this.sales7dList = data4;
        let data5 = result.map((item) => item.cost);
        this.costList = data5;
        (this.series = [
          {
            name: "Impressions",
            type: "column",
            data: this.impressionsList.filter(
              (_, i) => i % parseInt(this.impressionsList.length * 0.09) === 0
            ),
          },
          {
            name: "Clicks",
            type: "line",
            data: this.clicksList.filter(
              (_, i) => i % parseInt(this.impressionsList.length * 0.09) === 0
            ),
          },
        ]),
          (this.chartOptions = {
            labels: this.date.filter(
              (_, i) => i % parseInt(this.impressionsList.length * 0.09) === 0
            ),
          });
        this.series1 = [
          {
            data: this.sales7dList.filter(
              (_, i) => i % parseInt(this.sales7dList.length * 0.09) === 0
            ),
          },
          {
            data: this.costList.filter(
              (_, i) => i % parseInt(this.sales7dList.length * 0.09) === 0
            ),
          },
        ];
        this.chartOptions1 = {
          xaxis: {
            categories: this.date.filter(
              (_, i) => i % parseInt(this.sales7dList.length * 0.09) === 0
            ),
          },
        };
        this.$q.loading.hide();
      });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

body {
  font-family: "Montserrat", sans-serif !important;
}

.left-pad {
  margin-left: 30px;
  color: #102689;
  font-weight: bold;
  text-align: center;
  font-weight: bold;
}

.box-graph h5 {
  font-weight: bold;
  margin-top: 5px;
}

.dropdown {
  margin-left: 970px;
  margin-bottom: 20px;
  color: black;
  font-size: 15px;
}

.title-1 {
  display: flex;
  justify-content: center;
  background-color: #102689;
  color: white;
  font-size: 25px;
  font-weight: bold;
  letter-spacing: 0.97px;
  border-radius: 10px 10px 0px 0px;
}

.title h5 {
  font-weight: bold;
}

.apexcharts-toolbar {
  display: none !important;
}

.boxdashboard {
  border-radius: 5px;
  background-color: white;
  box-shadow: 0px 3px 6px #9bddd3;
}

.boxdashboard .row {
  display: flex;
  justify-content: center;
}

.boxdashboard .num {
  font-size: 22px;
  font-weight: 700;
}

.graph {
  margin-top: 10px;
  box-shadow: 0px 3px 6px #9bddd3;
  border-radius: 10px;
  background-color: white;
  margin-right: 5px;
}

.report-button {
  align-items: center;
  justify-content: center;
  display: flex;
}</style>
